import { render, staticRenderFns } from "./CommodityByPicksList.vue?vue&type=template&id=a3ec7998"
import script from "./CommodityByPicksList.vue?vue&type=script&lang=js"
export * from "./CommodityByPicksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports